// =============================================================================
// AppFooter
//
// The thin centred footer that sits below every page's main card.
// Replaces the inline footer block that lived (duplicated) in
// FormPage, BookedTripsPage, and LoginPage.
//
// Renders two pieces on one line:
//
//   Powered by Wisdom Weave  ·  v1.0.0
//
// The semver comes from `apps/web/package.json#version`, injected
// at build time via the `__APP_VERSION__` global in
// `vite.config.ts`. Bump the version in `package.json` + add a
// section to `CHANGELOG.md` whenever you ship a release.
//
// The build SHA used to be rendered next to the semver, but that
// loop turned into a whack-a-mole because the Cloud Build trigger
// for this project is configured with an inline / auto-detect
// build config rather than reading `cloudbuild.yaml` from the
// repo. Every attempt at piping `SHORT_SHA` into the bundle (build-
// arg → ENV → process.env, a dotfile on disk, a generated TS
// module) silently ended up baking in the committed default. Map
// versions to commits via `CHANGELOG.md` + git tags when you
// actually need the bidirectional lookup — far rarer than the
// front-end-trace use case the SHA was originally there to serve.
//
// The version is a button: clicking it opens the WhatsNewDialog, a
// plain-language "What's new" list aimed at non-technical staff (the
// friendly counterpart to CHANGELOG.md).
// =============================================================================

import { useState } from "react";
import { WhatsNewDialog } from "./WhatsNewDialog";

export function AppFooter() {
  const [whatsNewOpen, setWhatsNewOpen] = useState(false);

  return (
    <footer className="mx-auto mt-2 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-center text-xs text-muted-foreground">
      <span>
        Powered by{" "}
        <a
          className="font-bold text-foreground/90 hover:underline"
          href="https://wisdomweave.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Wisdom Weave
        </a>
      </span>
      <span aria-hidden="true">·</span>
      <button
        type="button"
        onClick={() => setWhatsNewOpen(true)}
        aria-label={`What's new in version ${__APP_VERSION__}`}
        className="rounded font-mono text-[0.7rem] text-foreground/70 transition hover:text-foreground focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        v{__APP_VERSION__}
      </button>
      <WhatsNewDialog open={whatsNewOpen} onOpenChange={setWhatsNewOpen} />
    </footer>
  );
}
